import { generateColorScale } from "$/modules/shared/lib/color";

const SHADE_KEYS = [
	"50",
	"100",
	"200",
	"300",
	"400",
	"500",
	"600",
	"700",
	"800",
	"900",
] as const;

/**
 * Override the application's primary/secondary CSS custom properties on <html> with a
 * generated scale from two brand hexes. Runs after the theme class is set,
 * inline styles win over the theme's class-level declarations regardless of
 * which design system or mode is active.
 */
export function applyPalette(primaryHex: string, secondaryHex: string): void {
	const root = document.documentElement.style;
	const primary = generateColorScale(primaryHex);
	const secondary = generateColorScale(secondaryHex);

	root.setProperty("--primary", `hsl(${primary.DEFAULT})`);
	root.setProperty("--primary-foreground", `hsl(${primary.foreground})`);
	root.setProperty("--secondary", `hsl(${secondary.DEFAULT})`);
	root.setProperty("--secondary-foreground", `hsl(${secondary.foreground})`);

	for (const key of SHADE_KEYS) {
		root.setProperty(`--primary-${key}`, `hsl(${primary[key]})`);
		root.setProperty(`--secondary-${key}`, `hsl(${secondary[key]})`);
	}
}
